import { forwardRef, useCallback, useMemo, useState } from 'react';
import clsx from 'clsx';
import { Box } from '@alf/uikit';
import { BONUS_SLIDER_BONUS_TYPES } from '@namespace/bonuses/src/constants';
// eslint-disable-next-line @alf/loop-deps
import { useBonusImageUrl } from '@namespace/bonuses/src/hooks/useBonusImageUrl';
import { useGetImage } from '@namespace/themes';
import { Description } from './Description';

import styles from '../../../index.module.css';

export const SliderItem = forwardRef(
  ({ bonus, activeBonusId, onClick, userCurrency }, ref) => {
    const [isImageLoadError, setIsImageLoadError] = useState(false);
    const {
      type,
      bonusId: fundsId,
      freespinId,
      isSelectedDeposit,
      imageColorAccent
    } = bonus;
    const bonusId = fundsId || freespinId;
    const isActiveBonus =
      (type === BONUS_SLIDER_BONUS_TYPES.DEFAULT && !activeBonusId) ||
      isSelectedDeposit ||
      bonusId === activeBonusId;
    const getImg = useGetImage();

    const { accentImageUrl = '', defaultImageUrl = '' } =
      useBonusImageUrl(bonus);

    const onBonusClick = useCallback(() => {
      onClick({ bonusId, type, isSelectedDeposit });
    }, [bonusId, isSelectedDeposit, onClick, type]);

    const currentImageUrl = useMemo(() => {
      if (isImageLoadError) {
        return `/images/bonuses/${getImg(
          'bonusPlaceholderLight',
          'bonusPlaceholderDark'
        )}.png`;
      }

      return isActiveBonus ? accentImageUrl : defaultImageUrl;
    }, [
      isImageLoadError,
      isActiveBonus,
      accentImageUrl,
      defaultImageUrl,
      getImg
    ]);

    return (
      <Box
        ref={ref}
        className={clsx(
          styles.itemContainer,
          isActiveBonus && styles.activeBonus,
          isActiveBonus && styles[imageColorAccent]
        )}
        justify="between"
        onClick={onBonusClick}
      >
        <Description
          isActiveBonus={isActiveBonus}
          bonus={bonus}
          userCurrency={userCurrency}
        />
        <Box>
          <img
            src={currentImageUrl}
            alt="bonus_slider_item_background"
            onError={() => setIsImageLoadError(true)}
            className={styles.image}
          />
        </Box>
      </Box>
    );
  }
);
